var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d5d6d5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-6 {\n        stroke: #2d312d;\n      }\n\n      .cls-2 {\n        fill: #f1eadd;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #abadab;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #000;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #e9bba4;\n      }\n\n      .cls-8 {\n        font-family: K2D-Regular, K2D;\n        font-size: 14px;\n      }\n\n      .cls-9 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-11 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-12 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-13 {\n        letter-spacing: -.04em;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.5,
    y: 1.5,
    width: 307,
    height: 248,
    rx: 19.73,
    ry: 19.73
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3,131.9c-11.25,18.28-19.48,38.41-24.27,59.34-.21.92-.4,1.94.09,2.75.65,1.08,2.15,1.21,3.41,1.22,65.67.38,131.34.76,197.01,1.14,5.81.03,13.25-1.15,14.51-6.82.75-3.35-1.23-6.64-3-9.58-8.21-13.66-13.68-28.97-15.97-44.74-.34-2.34-.78-4.98-2.74-6.3-1.37-.92-3.13-.94-4.78-.93-52.71.43-105.42.86-158.12,1.29-3.97.03-9.44,1.74-6.15,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.91,22.47c-2.45,36.44-2.84,73.01-.77,111.05,54.86,1.22,109.75,1.02,164.61-.6,2.05-.06,4.22-.16,5.9-1.33,2.83-1.96,3.11-5.97,3.1-9.41-.05-30.63-.36-61.25-.92-91.88-.03-1.69-.08-3.46-.93-4.91-1.68-2.88-5.59-3.32-8.92-3.43-54.15-1.78-108.37-1.21-162.07.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.41,34.71c-.39,27.92.33,55.85,2.17,83.71.1,1.57.28,3.3,1.41,4.39,1.2,1.15,3.05,1.2,4.71,1.19,44.93-.51,89.85-1.44,134.76-2.79,1.17-.04,2.42-.09,3.4-.74,1.72-1.14,1.93-3.54,1.96-5.6.37-24.72.53-49.45.46-74.18,0-1.92-.06-3.98-1.19-5.53-1.68-2.29-4.95-2.53-7.79-2.54-46.95-.3-93.91.7-139.89,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.1,141.66c-7.09,10.4-12.72,21.8-16.65,33.76-.5,1.53-.98,3.19-.5,4.72.99,3.15,5.08,3.8,8.38,3.89,54.48,1.42,108.99,1.73,163.48.95,1.33-.02,2.73-.06,3.88-.73,3.38-1.97,2.08-7.09.35-10.6-4.73-9.59-9.46-19.19-14.19-28.78-.68-1.39-1.43-2.84-2.73-3.68-1.29-.84-2.92-.92-4.46-.98-46.75-1.73-93.58-1.2-137.57,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.83,152.99l154.62-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.93,164.96c55.47-.88,110.94-1.76,166.4-2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.3,174.92c58.04-.57,116.08-1.15,174.13-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.14,141.72c-5.11,14.25-9.85,28.64-14.2,43.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.49,142.9c-2.12,13.73-4.25,27.45-6.37,41.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.26,141.68c-2.44,13.83-3.53,27.89-3.24,41.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.05,140.45c-2.88,14.73-4.19,29.77-3.9,44.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.39,140.11l-2.82,45.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.5,142.54l-.97,41.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.5,140.07l-1.08,44.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.04,141.71c.13,14.51.26,29.02.39,43.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.67,141.69c.93,14.39,1.85,28.77,2.78,43.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.73,140.09c.94,15,2.79,29.95,5.51,44.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.73,140.08c.99,14.84,3.38,29.59,7.13,43.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.1,142.52c.67,14.07,3.12,28.05,7.28,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.57,141.73l11.27,42.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.69,141.67c12.44-2.17,25.93,4.08,32.3,14.99,2.61,4.46,4.07,9.5,6.5,14.07s6.2,8.85,11.26,9.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.21,178.05c-7.59,11.88-10.06,26.92-6.65,40.61.91,3.66,2.26,7.3,4.66,10.21s5.99,5.02,9.76,4.93c5.87-.13,10.37-5.24,13.18-10.39,4.38-8.02,6.62-17.19,6.43-26.33-.11-5.29-1.08-10.69-3.76-15.25s-7.29-8.19-12.54-8.79-10.98,2.36-11.07,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.36,189.6c10.09,3.75,20.98,5.32,31.72,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.31,173.85c-.37,6.51-.75,13.02-1.12,19.53"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(68.7 64.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.82,
    y: 0
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 21.87,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.32,
    y: 0
  }, "t i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 41.29,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.02,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 57.36,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 64.23,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.78,
    y: 0
  }, "y() =&gt; {"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16.8,
    xmlSpace: "preserve"
  }, "    s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 21.53,
    y: 16.8
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.5,
    y: 16.8
  }, "tI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 37.9,
    y: 16.8
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.63,
    y: 16.8
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 53.97,
    y: 16.8
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 60.84,
    y: 16.8
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 67.4,
    y: 16.8
  }, "y(t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 85.37,
    y: 16.8
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 90.69,
    y: 16.8
  }, "ue)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33.6
  }, "}")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.dc46f748e95ddd9b892496e46b93525d.svg";
export { ForwardRef as ReactComponent };